export default __webpack_public_path__ + "static/img19h-5be84bb4f7b0a14253269b0ae8cfb93b.jpg";